import { render, staticRenderFns } from "./RelatorioCronogramaJobView.vue?vue&type=template&id=196b9e07&scoped=true"
import script from "./RelatorioCronogramaJobView.vue?vue&type=script&lang=js"
export * from "./RelatorioCronogramaJobView.vue?vue&type=script&lang=js"
import style0 from "./RelatorioCronogramaJobView.vue?vue&type=style&index=0&id=196b9e07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196b9e07",
  null
  
)

export default component.exports